export default "__VITE_ASSET__Cvn5oWEn__"